import {
  ADD_ROLE,
  GET_ROLES,
  EDIT_ROLE,
  REMOVE_ROLE,
} from "../actions/role-actions";
import { ApiRequestState } from "../../types/state-management";

const initialState = {
  loading: false,
  data: [],
  error: null,
};

const roleReducer = (state = initialState, action: any): ApiRequestState => {
  switch (action.type) {
    case (ADD_ROLE.REQUEST,
    GET_ROLES.REQUEST,
    EDIT_ROLE.REQUEST,
    REMOVE_ROLE.REQUEST):
      return {
        ...state,
        loading: true,
        error: null,
      };
    case (ADD_ROLE.SUCCESS,
    GET_ROLES.SUCCESS,
    EDIT_ROLE.SUCCESS,
    REMOVE_ROLE.SUCCESS):
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case (ADD_ROLE.FAILURE,
    GET_ROLES.FAILURE,
    EDIT_ROLE.FAILURE,
    REMOVE_ROLE.FAILURE):
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export { roleReducer };
